module.exports = __webpack_public_path__ + "img/module.49da125e.svg";